import { render } from "./UserLayout.vue?vue&type=template&id=332c4158&scoped=true"
import script from "./UserLayout.vue?vue&type=script&lang=js"
export * from "./UserLayout.vue?vue&type=script&lang=js"

import "./UserLayout.vue?vue&type=style&index=0&id=332c4158&lang=less&scoped=true"

import exportComponent from "/root/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-332c4158"]])

export default __exports__